import { Model } from './Model'
import {
    EnergyProductionConsumptionSummaryDataType,
    EnergyProductionConsumptionSummaryPeriodRawDataType
} from '@/types'

export type EnergyProductionConsumptionSummaryPeriodDataType = {
    max: number
    sum: number
}

export class EnergyProductionConsumptionSummary {
    end_date?: Date

    past_seven_days?: EnergyProductionConsumptionSummaryPeriodDataType

    month_to_date?: EnergyProductionConsumptionSummaryPeriodDataType

    life_time?: EnergyProductionConsumptionSummaryPeriodDataType

    today?: EnergyProductionConsumptionSummaryPeriodDataType

    yesterday?: EnergyProductionConsumptionSummaryPeriodDataType

    last_month?: EnergyProductionConsumptionSummaryPeriodDataType

    year_to_date?: EnergyProductionConsumptionSummaryPeriodDataType

    values: number[]

    constructor(data: EnergyProductionConsumptionSummaryDataType) {
        this.end_date = Model.toDate(data.end_date)
        this.past_seven_days = this.parseRawPeriodData(data.past_seven_days)
        this.month_to_date = this.parseRawPeriodData(data.month_to_date)
        this.life_time = this.parseRawPeriodData(data.life_time)
        this.today = this.parseRawPeriodData(data.today)
        this.yesterday = this.parseRawPeriodData(data.yesterday)
        this.last_month = this.parseRawPeriodData(data.last_month)
        this.year_to_date = this.parseRawPeriodData(data.year_to_date)
        this.values = data.values?.map
            ? data.values?.map(item => Model.toNumber(item, 0) as number)
            : []
    }

    parseRawPeriodData(data: EnergyProductionConsumptionSummaryPeriodRawDataType):
        EnergyProductionConsumptionSummaryPeriodDataType | undefined {
        if (typeof data === 'undefined') {
            return undefined
        }
        if (typeof data === 'number') {
            return {
                max: data,
                sum: data
            }
        }
        return data
            ? {
                max: Model.toNumber(data.max, 0) as number,
                sum: Model.toNumber(data.sum, 0) as number
            }
            : undefined
    }
}
